import { MINIMUM_DISCOUNT_TO_SHOW_PERCENTAGE_BADGE } from 'constants/content'
import getValueOffPercent from 'lib/offer/getValueOffPercent'
import type { BaseRatePackageView } from 'selectors/offerPage/offerPageSelectors'

export function getAlwaysOnMobileRateAvailability(
  packageView: App.OfferPackageOptionView,
  useDynamicCancellationPolicies: boolean,
  hasAvailableRate: boolean,
  checkIn: string | undefined,
  rooms: Array<App.Occupants>,
  fetching: boolean,
  availableForPurchase: boolean | undefined,
) {
  const dynamicHotelAvailable = ((useDynamicCancellationPolicies && hasAvailableRate && checkIn && !fetching) || !useDynamicCancellationPolicies || !checkIn || fetching)
  const hotelAvailable = packageView.hotelAvailable && dynamicHotelAvailable
  const canPurchase = availableForPurchase && packageView.capacityValid && hotelAvailable
  // Preserve the existing presence check: an empty rooms array is intentionally truthy here.
  const canBuyNow = !!checkIn && !!rooms && canPurchase && !fetching && packageView.fromCalendarInfo
  return { hotelAvailable, canPurchase, canBuyNow }
}

export function getAlwaysOnMobileRateValue(
  packageView: App.OfferPackageOptionView,
  baseRatePackageView: BaseRatePackageView | undefined,
  canViewLuxPlusBenefits: boolean,
  isDiscountPillHidden: boolean | undefined,
  canPurchase: boolean | undefined,
  previewMode: boolean,
) {
  const { package: pkg, hotelDiscountPercent, bundledDiscountPercent } = packageView
  const shouldShowDiscountPercent = hotelDiscountPercent >= MINIMUM_DISCOUNT_TO_SHOW_PERCENTAGE_BADGE
  const shouldShowBundledDiscountPercent = bundledDiscountPercent >= MINIMUM_DISCOUNT_TO_SHOW_PERCENTAGE_BADGE
  const highestDiscountPercent = hotelDiscountPercent > bundledDiscountPercent ? hotelDiscountPercent : bundledDiscountPercent
  const shouldShowDiscount = !isDiscountPillHidden && (shouldShowDiscountPercent || shouldShowBundledDiscountPercent) && (canPurchase || previewMode) && !pkg.roomRate?.inclusionsHideValue

  const baseRateValue = canViewLuxPlusBenefits ? baseRatePackageView?.memberValue : baseRatePackageView?.value
  const inclusionsAmount = (canViewLuxPlusBenefits ? pkg.totalInclusionsAmount : pkg.inclusionsAmount) ?? 0
  const pkgValueOrPkgMemberValue = canViewLuxPlusBenefits ? pkg.memberValue : pkg.value
  const packageViewHotelValueOrMemberHotelValue = (canViewLuxPlusBenefits ? packageView.hotelMemberValue : packageView.hotelValue) ?? 0

  // A base-rate comparison is only used when it improves the existing discount.
  if (baseRateValue && (baseRateValue + inclusionsAmount) > pkgValueOrPkgMemberValue) {
    const displayedHotelValue = baseRateValue + inclusionsAmount + (packageView.propertyFees ?? 0)
    const displayedHotelDiscountPercent = getValueOffPercent(displayedHotelValue, packageView.hotelPrice)
    if (displayedHotelDiscountPercent > highestDiscountPercent) {
      return { shouldShowDiscount, valuedUpTo: { value: displayedHotelValue, percent: displayedHotelDiscountPercent } }
    }
  }
  return { shouldShowDiscount, valuedUpTo: { value: packageViewHotelValueOrMemberHotelValue, percent: highestDiscountPercent } }
}
